import { FC } from 'react';

import { Grid } from '@mui/material';
import { Bank, DiscordLogo, MediumLogo, TwitterLogo, YoutubeLogo } from 'phosphor-react';

import { primaryColors } from '~components/theme/styles/colors';

import { ImageVestaLogoV2 } from '../../images';

import { SocialLink } from './systemStats';

export const AccountDialOverviewFooter: FC = () => {
  return (
    <Grid container alignItems={'center'} justifyContent={'center'} spacing={4}>
      <Grid item xs={4}>
        <SocialLink
          label="Join our Discord Community!"
          href="https://discord.gg/yNc6Cm638"
          icon={<DiscordLogo size={22} color="#b3b4c1" weight="regular" />}
        />
      </Grid>
      <Grid item xs={4}>
        <SocialLink
          label="Follow us on Twitter!"
          href="https://twitter.com/vestafinance"
          icon={<TwitterLogo size={22} color="#b3b4c1" weight="regular" />}
        />
      </Grid>
      <Grid item xs={4}>
        <SocialLink
          label="Subscribe to our Medium!"
          href="https://medium.com/@VestaFinance"
          icon={<MediumLogo size={22} color="#b3b4c1" weight="regular" />}
        />
      </Grid>
      <Grid item xs={4}>
        <SocialLink
          label="Check out our community videos!"
          href=""
          icon={<YoutubeLogo size={22} color="#b3b4c1" weight="regular" />}
        />
      </Grid>
      <Grid item xs={4}>
        <SocialLink
          label="Participate in governance"
          href="https://curia.vestafinance.xyz/"
          icon={<Bank size={22} color="#b3b4c1" weight="regular" />}
        />
      </Grid>
      <Grid item xs={4}>
        <SocialLink
          label="Docs & Whitepaper"
          href="https://docs.vestafinance.xyz/"
          icon={<ImageVestaLogoV2 background={primaryColors[100]} width={22} height={22} />}
        />
      </Grid>
    </Grid>
  );
};
